/**
 * Accounts allowed to have clickable links in their descriptions and bio.
 * Hardcoded while the list stays small; adding an account is a PR + deploy.
 */
const TRUSTED_USERNAMES = ['hl-library', 'musehub-audio']

export const TRUSTED_LINK_ACCOUNTS = new Set(
    TRUSTED_USERNAMES.map(username => username.toLowerCase()),
)
